import React, { useState } from "react";
import "./approveclaim.css";

const initialApprovedClaims = Array.from({ length: 9 }, (_, index) => ({
  id: `FM490${40 + index}`,
  status: "Approved", // Setting status as Approved
}));

const ApprovedClaimsList = () => {
  const [search, setSearch] = useState("");

  const filteredClaims = initialApprovedClaims.filter((claim) =>
    claim.id.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="main-card">
      <h2>All Approved Claims</h2>
      <input
        type="text"
        placeholder="Search"
        className="search-bar"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div className="card-container">
        {filteredClaims.length > 0 ? (
          filteredClaims.map((claim, index) => (
            <div className="box" key={index}>
              <div className="box-content">
                <p className="claim-id">Claim {claim.id}</p>
                <p className="status">
                  <span className="double-green-tick">✔✔</span>
                  <span className="approved-text">{claim.status}</span>
                </p>
              </div>
              <button className="preview-button">Preview</button>
            </div>
          ))
        ) : (
          <p className="no-results">No matching approved claims found.</p>
        )}
      </div>     
    </div>
  );
};

export default ApprovedClaimsList;
